<template>
  <div class="no-login" @click="loginFn">
    <img :src="nullBg" alt />
    <p class="no-login-tip">
      <span>未登录，</span>
      <span class="highlight">点击登录</span>
    </p>
  </div>
</template>

<script>
export default {
  name: "no-login",
  props: {
    msg: {
      type: String,
      require: true,
      default: "去看看",
    },
    link: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      nullBg: "https://o.bysjy.com.cn/kzp/template/un-login.png",
    };
  },
  methods: {
    loginFn: function () {
      this.$util.errorFn("请登录");
    },
  },
};
</script>

<style lang="scss" scoped>
.no-login {
  text-align: center;
  cursor: pointer;

  img {
    width: 0.9rem;
    height: 0.9rem;
  }

  .highlight {
    color: $lightColor;
  }

  span,
  a {
    font-size: 16px;
    line-height: 1.5;
  }

  .no-login-tip {
    color: #999999;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/NoLogin.vue